module.exports = __webpack_public_path__ + "static/domestic_mental_obj03@2x-fee62d54065502cadc620d0bf3e5e832.jpg";